import { faTh, faThList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaCheck, FaClock, FaTimes } from 'react-icons/fa';
import { MdKeyboardArrowLeft, MdOutlineKeyboardArrowRight, MdFirstPage, MdLastPage  } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import defaultImage from "../../images/default.jpg";
import {
    EVENTS_BASE_URL,
    EVENTS_FOR_MLT,
    EVENT_STATUS_URL,
    GUEST_MLT,
    PROCESS_MLT_INVITATION
} from '../ApiDetails.js';
import { notifyError, notifyInfo, notifySuccess } from '../../utilities/Notification.tsx';

function LeftContainerEventMlt({
    setFilteredEventDates,
    filters
}) {
    const [statuses, setStatuses] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [events, setEvents] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [sortBy, setSortBy] = useState("Newest");
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const itemsPerPage = 6;
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [viewMode, setViewMode] = useState("card");

    const [isWide, setIsWide] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 1024px)");

        // Set initial value
        setIsWide(mediaQuery.matches);

        // Listener for changes
        const handler = (e) => {
            setIsWide(e.matches);
            if (!e.matches) setViewMode("card");
        };
        mediaQuery.addEventListener("change", handler);

        return () => mediaQuery.removeEventListener("change", handler);
    }, []);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await axios.get(EVENTS_FOR_MLT);
                if (response.status != 200) {
                    throw new Error("Network response was not ok");
                }
                const eventData = response.data;
                setEvents([...eventData.map(event => {
                    if (event.siteCode==="OFF") event.onelinerAddress = event.eventAddress.replace("\r\n", " ").replace("\r", " ").replace("\n", " "); else {
                        if ((event.cityName!=="") && (event.cityName!=="null") && (event.cityName!==null)) event.onelinerAddress = event.cityName;
                        if ((event.stateName!=="") && (event.stateName!=="null") && (event.stateName!==null)) event.onelinerAddress += (event.onelinerAddress!=="" ? ", " : "") + event.stateName;
                        if ((event.countryName!=="") && (event.countryName!=="null") && (event.countryName!==null)) event.onelinerAddress += (event.onelinerAddress!=="" ? ", " : "") + event.countryName;
                    }
                    return event;
                })]);

                const uniqueStatuses = (await axios.get(EVENT_STATUS_URL)).data;
                setStatuses(uniqueStatuses);

                const openEventDates = eventData
                    .filter((event) => event.eventStatus.toLowerCase() === "open event")
                    .map((event) => new Date(event.eventDate));

                setSelectedStatuses(uniqueStatuses);
                setFilteredEventDates(openEventDates);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, [setFilteredEventDates]);


    const handleClick = async (currentEvent, status) => {
        if (currentEvent.eventStatus === "Attendance confirmed") {
            notifyInfo('Info', 'Already Attendance confirmed');
            return;
        }

        await ProcessEventInvitation(status, currentEvent);
    };

    const ProcessEventInvitation = async (status, currentEvent) => {
        await axios.get(`${EVENTS_BASE_URL}/${currentEvent.id}/${GUEST_MLT}`)
            .then(async response => {
                const guests = response.data.guests;
                if (guests !== null && guests.some(guest => guest.userId == localStorage.getItem('userId') && guest.status === status)) {
                    notifyInfo('Info', `You're already ${status} in this event`);
                    return;
                }

                var data = new FormData();
                data.append("status", status);
                data.append("comment", 'NA');

                await axios.post(`${PROCESS_MLT_INVITATION}/${currentEvent.id}`, data)
                    .then(response => {
                        if (response.data > 0) {
                            notifySuccess(`${status}!`, 'If your plans change, please contact Admin');
                            setEvents([...events.map(event => {
                                if (event.id === currentEvent.id) {
                                    event.userStatus = status;
                                }

                                return event;
                            })]);
                        } else {
                            notifyError('Oops!', 'Something went wrong while processing invitation');
                        }
                    })
                    .catch(error => {
                        console.error('Error updating the details: ', error);
                        notifyError('Oops!', 'Something went wrong while processing invitation');
                    });
            })
            .catch(error => {
                console.error('Error updating the details: ', error);
                notifyError('Oops!', 'Something went wrong while processing invitation');
            });
    };

    const isDateInRange = (
        eventDate,
        eventEndDate,
        selectedDate,
        selectedEndDate
    ) => {
        const eventStart = new Date(eventDate);
        const eventEnd = new Date(eventEndDate || eventDate);

        const selectedStart = selectedDate ? new Date(selectedDate) : null;
        const selectedEnd = selectedEndDate ? new Date(selectedEndDate) : null;

        return (
            (!selectedStart || eventStart >= selectedStart) &&
            (!selectedEnd || eventEnd <= selectedEnd)
        );
    };

    useEffect(() => {
        if (events) {
            const filteredData = events.filter((event) => {
                const statusMatch =
                    selectedStatuses.length > 0 &&
                    selectedStatuses.includes(event.eventStatus);

                const dateMatch =
                    (selectedDate === "" && selectedEndDate === "") ||

                    isDateInRange(
                        event.eventDate,
                        event.eventEndDate,
                        selectedDate,
                        selectedEndDate
                    );

                const myEventsMatch = filters.UpComingEvents && event.category.includes("Upcoming");
                const otherFamilyEventsMatch = filters.EventsWithNewComments && event.category.includes('New Comments');
                const needsFamilyMembersMatch = filters.EventSiteforOthers && event.category.includes('SiteCodeOFF');

                return (
                    statusMatch &&
                    dateMatch &&
                    (myEventsMatch || otherFamilyEventsMatch || needsFamilyMembersMatch)
                );

            });

            const filteredDates = filteredEvents.map(event => ({
                eventDate: event.eventDate,
                eventEndDate: event.eventEndDate,
                createdDate: event.createdDate,
                eventStatus: event.eventStatus,
                eventTitle: event.name,
                cityName: event.cityName,         // Include city name
                stateName: event.stateName,       // Include state name
                region: event.region,             // Include region
                countryName: event.countryName,   // Include country name
                requestedBy: event.requestedBy,   // Include who requested the event
                coverImage: event.coverImage      // Include event cover image if needed
            }));

            setFilteredEventDates(filteredDates);
            setFilteredEvents(filteredData);
        }
    }, [events, sortBy, selectedEndDate, selectedDate, selectedStatuses, filters]);

    const sortedEvents = [...filteredEvents].sort((a, b) => {
        if (sortBy === "Newest") {
            return new Date(b.eventDate) - new Date(a.eventDate);
        } else if (sortBy === "Oldest") {
            return new Date(a.eventDate) - new Date(b.eventDate);
        } else if (sortBy === "A to Z") {
            return a.name.localeCompare(b.name);
        } else if (sortBy === "Z to A") {
            return b.name.localeCompare(a.name);
        }
        return 0;
    });

    const totalPages = Math.ceil(sortedEvents.length / itemsPerPage);
    const currentEvents = sortedEvents.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageClick = (pageNumber) => {
        if (totalPages==0) return;
        setCurrentPage(pageNumber);
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const isMobile = window.innerWidth <= 400;
        const maxPageNumbersToShow = isMobile ? 2 : 5;

        let startPage = Math.max(
            1,
            currentPage - Math.floor(maxPageNumbersToShow / 2)
        );
        let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

        if (endPage - startPage + 1 < maxPageNumbersToShow) {
            startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return pageNumbers;
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const handleStatusClick = (status) => {
        setSelectedStatuses((prevStatuses) =>
            prevStatuses.includes(status)
                ? prevStatuses.filter((s) => s !== status)
                : [...prevStatuses, status]
        );
    };

    return (
        <div
            className="leftcontainer d-flex flex-column progress-bar bg-white rounded-end"
            aria-valuenow="60"
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ minHeight: "500px" }}
        >
            <div className="leftsearchbox">
                <div className="container-fluid d-flex align-items-center">
                    <div className="status-buttons mb-0">
                    <h6 className="calendar-headerh6 mr-2">Status</h6>
                        {statuses.map((status) => (
                            <><div
                                key={status}
                                className={`status-button ${selectedStatuses.includes(status) ? "selected" : ""}`}
                                onClick={() => handleStatusClick(status)}
                            >
                                <span>{status}</span>
                            </div>
                                {status == 'Pending documentation' ? <br /> : ""}
                            </>
                        ))}
                    </div>
                    {isWide ? (
                    <div className="col-md-1">
                        <FontAwesomeIcon
                            icon={viewMode === "card" ? faThList : faTh}
                            onClick={() => setViewMode(viewMode === "card" ? "list" : "card")}
                            style={{ cursor: 'pointer', fontSize: '20px', marginTop: '5px' }}
                        />
                    </div>
                    ) : ("")}
                </div>
                <br/>
                <div className="container-fluid align-items-center">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="mb-3">
                                <div className="input-group mb-0">
                                    <label
                                        className="input-group-text input-group-text-custom"
                                        htmlFor="sortBy"
                                    >
                                        Sort By
                                    </label>
                                    <select
                                        className="form-control-custom rounded form-select"
                                        aria-label="Sort By"
                                        id="sortBy"
                                        value={sortBy}
                                        onChange={(e) => setSortBy(e.target.value)}
                                    >
                                        <option value="Newest">Newest</option>
                                        <option value="Oldest">Oldest</option>
                                        <option value="A to Z">A to Z</option>
                                        <option value="Z to A">Z to A</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="input-group mb-0">
                                <label
                                    htmlFor="dateInput"
                                    className="input-group-text input-group-text-custom"
                                >
                                    Date Interval
                                </label>
                                <div
                                    style={{ display: "flex", alignItems: "center", gap: "10px" }}
                                    className="requestorMainPageDateInterval"
                                >
                                    <input
                                        type="date"
                                        className="form-control-custom rounded form-control selectDateInput"
                                        id="dateInput"
                                        value={selectedDate}
                                        onChange={(e) => setSelectedDate(e.target.value)}
                                    />
                                    <span style={{ fontWeight: "bold" }}>to</span>
                                    <input
                                        type="date"
                                        className="form-control-custom rounded form-control selectDateInput"
                                        id="dateInput1"
                                        value={selectedEndDate}
                                        onChange={(e) => setSelectedEndDate(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="listitems">
                <div className="row card-group text-wrap text-start m-2 flex-wrap">
                    {currentEvents.map((event) => (
                        <div key={event.id} className={viewMode === 'card' ? 'col-md-4 p-2' : 'list-group'}>
                            <div
                                onClick={() => {
                                    navigate(`/GetDetailEventMlt/${event.id}`, { state: { mltEvent: event.mltEvent }, });
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <div className={`card rounded ${viewMode === 'card' ? 'align-items-stretch' : 'list-group-item'} list-card`}>
                                    {event && (
                                        <div className={viewMode === 'card' ? "card-img-container" : "col-md-1 d-flex justify-content-between align-items-start d-none"}>
                                            {event.coverImage
                                                ? <img
                                                    className={viewMode === 'card' ? "card-img-top-custom card-img-top rounded" : "d-flex justify-content-between align-items-start"}
                                                    src={event.coverImage ?? defaultImage}
                                                    alt={event.name} />
                                                : <div className='card-noimg-text'>
                                                    <span className='line-clamp-3'>{event.name}</span>
                                                </div>}
                                        </div>
                                    )}
                                    <div className={`card-body-custom card-body ${viewMode === 'list' ? 'list-body col-md-8' : ''}`}>
                                        <h6 className={viewMode === 'list' ? 'list-header-custom line-clamp-2' : 'card-header-custom line-clamp-2'} title={event.name}>
                                            {event.name}
                                        </h6>
                                        <div className={viewMode === 'list' ? 'list-text-custom' : 'event-card-text-custom'}>
                                            {event.guests.filter(guest => guest.status === 'Confirmed').length > 0 && (
                                                <>
                                                    with <b>{event.guests.filter(guest => guest.status === 'Confirmed').map(guest => `${guest.user.firstName} ${guest.user.lastName}`).join(', ')}</b>
                                                </>
                                            )}

                                            {  (event.eventStatus === "Open event") 
                                            && (event.guests.filter(guest => guest.status === 'Confirmed').length < event.mltNum)                                         
                                            && (
                                                <>
                                                    <div>Still accepting MLT members <b>{event.guests.filter(guest => guest.status === 'Confirmed').length} out of {event.mltNum}</b></div>
                                                </>
                                            )}
                                            <div>
                                                <b>
                                                    {new Date(event.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})} to{" "}
                                                    {new Date(event.eventEndDate).toLocaleDateString('en-US', {timeZone: 'UTC'})} •{" "}
                                                    {event.onelinerAddress}
                                                </b>
                                            </div>
                                            <br />
                                            <span>
                                                Created by {event.requestedBy} on{" "}
                                                {new Date(event.createdDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}
                                            </span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className={`card-footer card-footer-custom ${viewMode === 'card' ? '' : 'event-btn col-md-4'}`}>
                                            <Link to={`/GetDetailEventMlt/${event.eventId}`} className={`card-footer-button btn rounded-pill ${event.eventStatus}`}> {event.eventStatus.toUpperCase()}</Link>
                                            <div
                                                className="float-right-custom"
                                                style={{ display: "flex" }}
                                            >
                                                {(event.eventStatus.toLowerCase() === "open event") &&
                                                    <div className="guest-actions">
                                                        <button
                                                            className={`btn-remove ${event.userStatus === 'Declined' ? 'Declined' : ''}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleClick(event, "Declined")
                                                            }}
                                                            disabled={event.eventStatus.toLowerCase() !== "open event"}
                                                        >
                                                            <FaTimes />
                                                        </button>
                                                        <button
                                                            className={`btn-timer ${event.userStatus === 'Tentative' ? 'Tentative' : ''}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleClick(event, "Tentative");
                                                            }}
                                                        >
                                                            <FaClock />
                                                        </button>
                                                        <button
                                                            className={`btn-confirm ${event.userStatus === 'Confirmed' ? 'Confirm' : ''}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleClick(event, "Confirmed");
                                                            }}
                                                        >
                                                            <FaCheck />
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="paging align-items-center" style={{userSelect: 'none'}}>
                <span className="centered-text">
                    {(totalPages>0) && (<>{(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, sortedEvents.length)} OF{" "}</>)}
                    {sortedEvents.length} ELEMENTS &nbsp;&nbsp;
                </span>
                <nav>
                    <ul className="pagination justify-content-end" style={{ marginBottom: "17px", cursor: "pointer" }}>
                        <li className={`page-item ${((totalPages===0) || currentPage === 1) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdFirstPage /></span>
                        </li>
                        <li className={`page-item ${((totalPages===0) || currentPage === 1) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(currentPage - 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdKeyboardArrowLeft /></span>
                        </li>
                        {getPageNumbers().map((number) => (
                            <li key={number} className={`page-item ${currentPage === number ? "active" : ""}`}>
                                <span className="page-link" onClick={() => handlePageClick(number)} style={{ fontSize: "12px", padding: "4px 8px" }}>{number}</span>
                            </li>
                        ))}
                        <li className={`page-item ${((totalPages===0) || currentPage === totalPages) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(currentPage + 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdOutlineKeyboardArrowRight /></span>
                        </li>
                        <li className={`page-item ${((totalPages===0) || currentPage === totalPages) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(totalPages)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdLastPage /></span>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}

export default LeftContainerEventMlt;